import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { SIcon } from '@avalara/skylab-sdk/react';
import styled from 'styled-components';
import { setProgressBarCurrentStep } from '@avalara/bat-apps-shared/client/actions/progress-bar';
import IframePaymentContainer from '../../../containers/iframe-payment-container';
import { setCurrentOfferPage } from '../../../store/offer';
import { updateProductAnalytics } from '../../../lib/side-effects/analytics';
import { goToNextOfferStep, goToPreviousOfferStep } from '../../../lib/side-effects/offer-flow';
import { stepNames } from '../../../lib/side-effects/progress-bar';
import { selectState, selectIsNonAdmin } from '../../../selectors';
import { isEmbeddedSelector } from '../../../selectors/offer';
import { purchaseDeflectionWording } from '../../helpers';
import PaymentSelection from '../../shared/payment/payment-selection';
import { FormContainer } from '../styled/forms';
import SignInLink from '../sign-in-link';
import { Pages } from '../../../../shared/types/offers';
import { setNeedToFetchCybersourceData } from '../../../store/system';
const PaymentFormContainer = styled(FormContainer) `
  height: inherit;
`;
const OfferPaymentForm = (props) => {
    const { account: { isLoggedIn, paymentMethods, selectedPaymentMethod, }, data: { isLoading }, offer: { offerFlow }, } = useSelector(selectState);
    const dispatch = useDispatch();
    const history = useHistory();
    const isNonAdmin = useSelector(selectIsNonAdmin);
    const usingExistingPaymentMethod = !!selectedPaymentMethod;
    const hideIframe = usingExistingPaymentMethod || (isLoggedIn && isNonAdmin);
    const nextButtonAction = usingExistingPaymentMethod
        ? () => dispatch(goToNextOfferStep({ history }))
        : undefined;
    const isEmbedded = useSelector(isEmbeddedSelector);
    useEffect(() => {
        if (!hideIframe) {
            dispatch(setNeedToFetchCybersourceData(true));
        }
        else
            dispatch(setNeedToFetchCybersourceData(false));
    }, [hideIframe]);
    useEffect(() => {
        dispatch(setCurrentOfferPage(Pages.Payment));
        dispatch(setProgressBarCurrentStep(stepNames.paymentMethod));
        dispatch(updateProductAnalytics('purchase_start', !!offerFlow));
    }, []);
    if (isLoggedIn && isNonAdmin) {
        return (React.createElement(PaymentFormContainer, { isEmbedded: isEmbedded, className: 'pad-all-xl text-center' },
            React.createElement("p", { className: 'text-lg font-semibold' }, purchaseDeflectionWording)));
    }
    const goBack = () => {
        dispatch(goToPreviousOfferStep(history));
    };
    return (React.createElement(PaymentFormContainer, { id: 'payment-form-container', isEmbedded: isEmbedded },
        React.createElement("h1", { "data-ref": 'buy.payment.header' }, paymentMethods.length ? 'Select a payment method' : 'Add a credit card'),
        !isLoggedIn && React.createElement(SignInLink, null),
        paymentMethods.length ? React.createElement(PaymentSelection, null) : null,
        selectedPaymentMethod == null && React.createElement(IframePaymentContainer, { hideIframe: isLoading || hideIframe, adjustWidth: true }),
        props.isEmbedded && React.createElement("div", { className: 'text-right' },
            React.createElement("button", { className: 'secondary margin-right-lg', onClick: goBack }, "Back"),
            React.createElement("button", { className: 'primary icon-trailing', onClick: nextButtonAction },
                "Next ",
                React.createElement(SIcon, { name: 'arrow-circle-right' })))));
};
export default OfferPaymentForm;
